<template>
  <div class="avatar-crop flex flex-column">
    <div class="wrapper flex flex-1 flex-main-center flex-cross-center">
      <div v-if="defaultImage" class="image" :style="{'background-image':`url('${croppedImage||defaultImage}')`}"></div>
      <input type="file" class="upload" @change="fileChange" :accept="accept">
      <div v-if="showCropDialog" class="crop flex flex-main-center flex-cross-center" transition="crop">
        <div class="loading">
          <div class="v-beat v-beat-odd"></div>
          <div class="v-beat v-beat-even"></div>
          <div class="v-beat v-beat-odd"></div>
        </div>
        <div class="dialog" :style="{width:width+'px'}">
          <section :style="{height:height+'px'}" :class="{grab:!grabbing,grabbing:grabbing}">
            <div class="img-circle" v-if="showCircle"></div>
            <img :style="{width:scaleWidth+'px',height:scaleHeight+'px',left:scaleX+'px',top:scaleY+'px'}"
              @touchstart.prevent="cropDragBegin"
              @touchmove.prevent="cropDragMove"
              @touchend.prevent="cropDragEnd"
              :src="img?img.src:null">
          </section>
          <footer class="flex flex-main-center vux-1px-t">
            <button class="btn flex-1 vux-1px-r" @click="cropCancel">{{cancelText}}</button>
            <button class="btn flex-1" @click="cropOK">{{okText}}</button>
          </footer>
          <input class="scale" type="range" v-model="scale" value="100"
            min="100" max="200" step="1" @input="cropZoom">
        </div>
      </div>
      <p class="tips">点击更改头像</p>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    defaultImage: {
      type: String,
      default: ''
    },
    accept: {
      type: String,
      default: 'image/jpg,image/jpeg,image/png,image/gif'
    },
    quality: {
      type: Number,
      default: 0.8
    },
    showCircle: {
      type: Boolean,
      default: true
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    okText: {
      type: String,
      default: '确定'
    },
    width: {
      type: Number,
      default: 320
    },
    height: {
      type: Number,
      default: 320
    },
    returnBase64: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showCropDialog: false,
      selectedFile: null,
      // 裁剪后的图像
      croppedImage: null,
      img: null,
      scale: 100, // 缩放
      scaleX: 0,
      scaleY: 0,
      scaleLength: 0,
      scaleWidth: 0,
      scaleHeight: 0,
      drag: false,
      grabbing: false,
      beginX: 0,
      beginY: 0,
      beginLength: 0,
      canvas: null,
      context: null
    }
  },
  methods: {
    fileChange (e) {
      if (e.target.files.length === 0) {
        return false
      }
      this.selectedFile = e.target.files[0]
      this.showCropDialog = true
      // 读取本地图片转成base64显示到页面待使用
      const fr = new window.FileReader()
      fr.readAsDataURL(this.selectedFile)
      fr.onload = e => {
        this.img = new window.Image()
        this.img.src = fr.result
        this.img.onload = () => {
          // 按原始图片比例优先使用小值设置最低值
          if (this.img.naturalWidth > this.img.naturalHeight) {
            this.scaleHeight = this.height
            this.scaleWidth = Math.round(this.scaleHeight * this.img.naturalWidth / this.img.naturalHeight)
          } else {
            this.scaleWidth = this.width
            this.scaleHeight = Math.round(this.scaleWidth * this.img.naturalHeight / this.img.naturalWidth)
          }
          this.scaleX = -Math.round((this.scaleWidth - this.width) / 2)
          this.scaleY = -Math.round((this.scaleHeight - this.height) / 2)
          // 渲染到canvas
          this.canvas = document.createElement('canvas')
          this.canvas.width = this.width
          this.canvas.height = this.height
          this.canvas.setAttribute('style', 'position:absolute;left:0;top:0;opacity:0;z-index:-1')
          this.context = this.canvas.getContext('2d')
          this.cropToCanvas()
          document.body.appendChild(this.canvas)
        }
      }
    },
    cropDragBegin (e) {
      this.drag = true
      this.grabbing = true
      this.beginX = e.touches[0].pageX - e.target.offsetLeft
      this.beginY = e.touches[0].pageY - e.target.offsetTop
      if (e.touches.length === 2) {
        this.beginLength = this.beginLength === 0 ? this.cropTouchData(e).length : this.beginLength
      }
    },
    cropDragMove (e) {
      if (!this.drag) {
        return false
      }
      // 放大
      if (e.touches.length === 2) {
        this.scaleLength = this.cropTouchData(e).length
        this.scale = Math.min(200, Math.max(100, this.scaleLength / this.beginLength * 100))
        this.cropZoom()
      } else {
        this.scaleX = e.changedTouches[0].pageX - this.beginX
        this.scaleY = e.changedTouches[0].pageY - this.beginY
      }
      this.cropLimit()
    },
    cropDragEnd (e) {
      this.drag = false
      this.grabbing = false
      this.cropToCanvas()
    },
    cropToCanvas () {
      this.context.clearRect(0, 0, this.width, this.height)
      // 图像源x坐标
      const sx = Math.round(Math.abs(this.scaleX) * this.img.naturalWidth / this.scaleWidth)
      // 图像源y坐标
      const sy = Math.round(Math.abs(this.scaleY) * this.img.naturalHeight / this.scaleHeight)
      const sw = this.width * this.img.naturalWidth / this.scaleWidth
      const sh = this.height * this.img.naturalHeight / this.scaleHeight
      // fill white bg
      this.context.fillStyle = '#FFFFFF'
      this.context.fillRect(0, 0, this.width, this.height)
      this.context.drawImage(this.img, sx, sy, sw, sh, 0, 0, this.width, this.height / this.cropGetRatio())
    },
    cropZoom () {
      // 放大倍数
      const s = this.scale / 100
      // 按原始图片比例优先使用小值设置最低值
      if (this.img.naturalWidth > this.img.naturalHeight) {
        this.scaleHeight = this.height * s
        this.scaleWidth = this.scaleHeight * this.img.naturalWidth / this.img.naturalHeight
      } else {
        this.scaleWidth = this.width * s
        this.scaleHeight = this.scaleWidth * this.img.naturalHeight / this.img.naturalWidth
      }
      this.scaleX = -(this.scaleWidth - this.width) / 2
      this.scaleY = -(this.scaleHeight - this.width) / 2
      this.cropLimit()
      this.cropToCanvas()
    },
    // 获取多点触控
    cropTouchData (e) {
      if (e.touches.length < 2) {
        return
      }
      const x1 = e.touches[0].pageX
      const x2 = e.touches[1].pageX
      const x3 = (x1 <= x2 ? (x2 - x1) / 2 + x1 : (x1 - x2) / 2 + x2)
      const y1 = e.touches[0].pageY - this.scrollbar.scrollTop
      const y2 = e.touches[1].pageY - this.scrollbar.scrollTop
      const y3 = (y1 <= y2 ? (y2 - y1) / 2 + y1 : (y1 - y2) / 2 + y2)
      return {
        length: Math.round(Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2))),
        x: Math.round(x3),
        y: Math.round(y3)
      }
    },
    // 限制边界
    cropLimit () {
      if (this.scaleX < -(this.scaleWidth - this.width)) {
        this.scaleX = -(this.scaleWidth - this.width)
      }
      if (this.scaleY < -(this.scaleHeight - this.height)) {
        this.scaleY = -(this.scaleHeight - this.height)
      }
      if (this.scaleX > 0) {
        this.scaleX = 0
      }
      if (this.scaleY > 0) {
        this.scaleY = 0
      }
      if (this.scaleHeight === this.height) {
        this.scaleY = 0
      }
      if (this.scaleWidth === this.width) {
        this.scaleX = 0
      }
    },
    // 提交裁剪
    cropOK () {
      const data = this.canvas.toDataURL('image/jpeg', this.quality || 0.8)
      this.croppedImage = data
      if (this.returnBase64) {
        this.$emit('change', data)
      } else {
        const _data = window.atob(data.split(',')[1])
        const aBuffer = new ArrayBuffer(_data.length)
        const uBuffer = new Uint8Array(aBuffer)
        for (let i = 0; i < data.length; i++) {
          uBuffer[i] = data.charCodeAt(i)
        }
        const blob = new window.Blob([uBuffer], { type: 'image/jpeg' })
        this.$emit('change', blob)
      }
      this.cropCancel()
    },
    // 取消裁剪
    cropCancel () {
      this.showCropDialog = false
      this.scale = 100
      this.scaleX = 0
      this.scaleY = 0
      this.scaleLength = 0
      this.scaleWidth = 0
      this.scaleHeight = 0
      this.beginX = 0
      this.beginY = 0
      this.beginLength = 0
      this.canvas = null
      this.context = null
      if (this.canvas) {
        document.body.removeChild(this.canvas)
      }
      this.selectedFile.value = ''
    },
    // http://stackoverflow.com/questions/11929099/html5-canvas-drawimage-ratio-bug-ios
    cropGetRatio () {
      const ih = this.img.naturalHeight
      const canvas = document.createElement('canvas')
      canvas.width = 1
      canvas.height = ih
      const ctx = canvas.getContext('2d')
      ctx.drawImage(this.img, 0, 0)
      const data = ctx.getImageData(0, 0, 1, ih).data
      // search image edge pixel position in case it is squashed vertically.
      let sy = 0
      let ey = ih
      let py = ih
      while (py > sy) {
        const alpha = data[(py - 1) * 4 + 3]
        if (alpha === 0) {
          ey = py
        } else {
          sy = py
        }
        py = (ey + sy) >> 1
      }
      const ratio = (py / ih)
      return (ratio === 0) ? 1 : ratio
    }
  }
}
</script>
<style lang='stylus' scoped>
@import "./var.styl"
.avatar-crop
  margin 80px auto
  padding 10px
  border 2px solid lighten($color-primary, 50%)
  text-align center
  border-radius 4px
  .wrapper
    position relative
    width 180px
    height 180px
  .tips
    position absolute
    bottom -40px
  .image
  .upload
    position absolute
    left 0
    top 0
    width 100%
    height 100%
  .image
    background-size cover
    background-position center center
  .upload
    opacity 0
  .crop
    position fixed
    left 0
    top 0
    width 100%
    height 100%
    background-color rgba(0, 0, 0, .7)
    transition opacity .5s ease
    z-index 10
  .loading
    display none
  .dialog
    position relative
    background-color #FAFAFC
    border-radius 4px
    transition all .5s ease
    > section
      position relative
      overflow hidden
    .grab
      cursor grab
    .grab
      cursor grabbing
    img
      position absolute
      max-width none
    .btn
      height 48px
      line-height @height
      text-align center
      color #5F7B88
      font-size 16px
      border none
      background-color transparent
    .scale
      -webkit-appearance none
      position absolute
      left 12.5%
      bottom 88px
      width 75%
      border none
      outline none
      cursor pointer
      &::-webkit-slider-runnable-track
        width 100%
        height 2px
        cursor pointer
        background #efb708
      &::-webkit-slider-thumb
        height 20px
        width 20px
        border-radius 10px
        background #ffffff
        border 2px solid #efb708
        cursor pointer
        -webkit-appearance none
        margin-top -10px
      &::-moz-range-track
        width 100%
        height 2px
        cursor pointer
        background #efb708
      &::-moz-range-thumb
        height 16px
        width 16px
        border-radius 8px
        border 2px solid #efb708
        background #ffffff
        cursor pointer
      &::-ms-track
        width 100%
        height 1px
        cursor pointer
        background transparent
        border-color transparent
        color transparent
      &::-ms-fill-lower
        background rgba(0, 0, 0, 0.5)
        border 0px solid rgba(200, 200, 200, 0.2)
        border-radius 0px
        box-shadow 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0)
      &::-ms-fill-upper
        background rgba(0, 0, 0, 0.5)
        border 0px solid rgba(200, 200, 200, 0.2)
        border-radius 0px
        box-shadow 0px 0px 0px rgba(0, 0, 0, 0), 0px 0px 0px rgba(13, 13, 13, 0)
      &::-ms-thumb
        height 16px
        width 16px
        border-radius 8px
        background #ffffff
        cursor pointer
        height 1px
      &:focus
        &::-ms-fill-lower
          background: rgba(0, 0, 0, 0.5)
        &::-ms-fill-upper
          background rgba(0, 0, 0, 0.5)
</style>



// WEBPACK FOOTER //
// AvatarCrop.vue?237651d1